import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import TextField from './TextField';
import SingleChoiceField from './SingleChoiceField';

import FieldLimits from '../util/db_field_limits.json';
import { useHandleInputChange } from '../context-provider/InputFormContextProvider';

const COUNTY_OPTIONS = FieldLimits.work.counties;
const DISTRICT_OPTIONS = FieldLimits.work.districts;

const CountryCountyDistrictFields = ({
    str_countryFieldId,
    str_countyFieldId,
    str_districtFieldId,
    str_countryValue,
    str_currentCountyOption,
    str_currentDistrictOption
}) => {
    
    const handleInputChange = useHandleInputChange()
    
    const isCountryAustria = str_countryValue === 'Österreich' || str_countryValue === 'Austria'

    useEffect(() => {
        /**
         * Hide county and district fields if the current country value is not Austria.
         */
        if (!isCountryAustria) {
            handleInputChange({
                id: str_countyFieldId,
                value: '',
                hasError: false
            })
        }
    }, [str_countryValue])

    useEffect(() => {
        /**
         * Hide the district input field, if no county is selected.
         */
        if (!str_currentCountyOption) {
            str_currentDistrictOption = '';
            handleInputChange({
                id: str_districtFieldId,
                value: '',
                hasError: false
            })
        }
    }, [str_currentCountyOption])

    return (
        <>
        {/* Country field. */}
            <TextField
                str_id={str_countryFieldId}
                str_fieldTitle='Staat'
                str_chars={str_countryValue}
                b_isTextarea={false}
                int_maxLength={FieldLimits.address.countryName}
                b_isRequired={true}
            />
            {
                /* County field. */
                isCountryAustria &&
                <SingleChoiceField
                    str_id={str_countyFieldId}
                    str_fieldTitle='Bundesland'
                    str_currentOption={str_currentCountyOption}
                    arr_options={COUNTY_OPTIONS}
                />
            }
            {
                /* District field. */
                isCountryAustria && str_currentCountyOption &&
                <SingleChoiceField
                    str_id={str_districtFieldId}
                    str_fieldTitle='Bezirk'
                    str_currentOption={str_currentDistrictOption}
                    arr_options={DISTRICT_OPTIONS[str_currentCountyOption]}
                />
            }
        </>
    )
}

CountryCountyDistrictFields.propTypes = {
    str_countryFieldId: PropTypes.string.isRequired,
    str_countyFieldId: PropTypes.string.isRequired,
    str_districtFieldId: PropTypes.string.isRequired,
    str_countryValue: PropTypes.string,
    str_currentCountyOption: PropTypes.string,
    str_currentDistrictOption: PropTypes.string
}

export default CountryCountyDistrictFields
